import * as React from 'react';

import { locationsUrl } from 'src/utils/navigation';
import './Notifications.scss';
import notificationIcon from 'src/assets/notificationIcon';
import location from 'src/assets/locationIcon';
import creditIcon from 'src/assets/creditIcon';
import webIcon from 'src/assets/webIcon';
import settingIcon from 'src/assets/settingIcon';

interface INotificationsState {
  floatingIsOpen: boolean;
}

interface INotificationsProps {
  isLoggedIn: boolean;
}

export default class Notifications extends React.Component<
  any,
  INotificationsState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        id="my-orders-menu"
        onMouseOut={this.closeMenu}
        onMouseOver={this.openMenu}
        className="my-notification-menu"
      >
        <div
          className="my-orders-menu--my-account"
          onClick={this.handleMenuState}
        >
          <div className="my-orders-menu--info">
            {/* <span className="rp-notification-count">4</span> */}
            <img
              src={notificationIcon}
              alt="more icon"
              className="your-order-icon"
            />
            <div className="go-to-account" role="button" tabIndex={0}>
              <p className="rp-more-text">Notifications </p>
            </div>
          </div>
        </div>
        <div
          className={`my-orders-menu--my-account--fly-menu ${menuState}`}
          ref={ref => (this.flyMenuRef = ref)}
        >
          <p className="menu-item-heading">{t('menu.yourNotifications')}</p>

          {/* <a className="menu-item menu-link">
            <img src={creditIcon} alt="icon" className="menu-item-icon" />
            <span />
          </a> */}
          <a className="menu-item menu-link">
            <img
              src={webIcon}
              alt="icon"
              className="menu-item-icon notification-icon"
            />
            <span />
          </a>
          {/* <a className="menu-item menu-link">
            <img
              src={settingIcon}
              alt="icon"
              className="menu-item-icon notification-icon"
            />
            <span />
          </a> */}
        </div>
      </div>
    );
  }
}
